import React, { useState } from 'react';
import SiteModal from '../../Common/SiteModal';
import { TextInput, SubmitButton } from '../../Inputs/FormInputs';
import { CircularProgress } from '@material-ui/core';
import { Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import NumberFormatDollars from '../../Helpers/Formatters/NumberFormatDollars';
import * as yup from 'yup';
import { httpRequest } from '../../../httpRequest';

export default function GoalModal(props) {

  const { open, setClosed, updateGoals, currentPremiumCount, currentAppCount } = props;

  const defaultFormState = {
    submittedAppGoal: null,
    submittedPremiumGoal: null
  };

  const [formState, updateFormState] = useState(defaultFormState);
  const [pendingSave, setPendingSave] = useState(false);

  const { register, errors, handleSubmit } = useForm({
    validationSchema: GoalModal.ValidationSchema(currentAppCount, currentPremiumCount),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const submitForm = (data) => {
   
    setPendingSave(true);

    let baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;

    const queryParams = new URLSearchParams({
      PremiumGoal: data.submittedPremiumGoal.replaceAll(',','').replace('$',''),
      ApplicationGoal: data.submittedAppGoal
    });

    httpRequest.post(`${baseAddress}/api/Advisor/SetGoal?${queryParams.toString()}`).then(data => {
      if (data.success) {
        setPendingSave(false);
        updateGoals({ premiumGoal: data.premiumGoal, appGoal: data.applicationGoal })
        setClosed();
      }
    });
  }

  const modalBody = (
    <form id="fa-goals-form" onSubmit={handleSubmit(submitForm)}>
      <Row>
        <TextInput
          name="submittedAppGoal"
          id="submittedAppGoal"
          defaultValue={formState.submittedAppGoal}
          onChange={(e) => updateFormState({ ...formState, submittedAppGoal: e.value })}
          errors={errors && errors.submittedAppGoal}
          label="Submitted Application Goal"
          variant="outlined"
          inputRef={register}
        />
        <TextInput
          name="submittedPremiumGoal"
          id="submittedPremiumGoal"
          defaultValue={formState.submittedPremiumGoal}
          onChange={(e) => updateFormState({ ...formState, submittedPremiumGoal: e.value })}
          label="Submitted Premium Goal"
          errors={errors.submittedPremiumGoal}
          variant="outlined"
          inputRef={register}
          inputProps={{
            inputComponent: NumberFormatDollars,
            className: 'coverage-input',
          }}
        />
      </Row>
      <Col sm={12}>
        {
          pendingSave ? <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2em' }}><CircularProgress /></div>
            : <SubmitButton buttonText="SUBMIT" />
        }
      </Col>
    </form>
  );

  return <SiteModal open={open} onClose={setClosed} body={modalBody} title={'Your Goals'} />;
}

GoalModal.ValidationSchema = (submittedAppCount, submittedPremiumCount) => {

  return yup.object().shape({
    submittedAppGoal: yup.number()
      .typeError('Must be a number')
      .moreThan(submittedAppCount, 'Submitted App Goal must be greater than current Submitted App count')
      .max(1000000, 'Submitted App Goal must be between 1 and 1000000')
      .required('Submitted App Goal is required'),
    submittedPremiumGoal: yup.string().isValidPremiumGoal('Submitted Premium Goal is required', parseFloat(submittedPremiumCount), parseFloat(100000000))
  });
}


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/GoalModal.js